"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Icon_1 = require("../Icon");
require("./Button.scss");
function Button(props) {
    var discrete = false;
    var normal = false;
    var primary = false;
    var small = false;
    var minimal = false;
    switch (props.buttonType) {
        case 'discrete':
            discrete = true;
            break;
        case 'primary':
            primary = true;
            break;
        default:
            normal = true;
    }
    switch (props.buttonSize) {
        case 'small':
            small = true;
            break;
        case 'minimal':
            minimal = true;
            break;
        default:
    }
    var iconObject = props.icon ? React.createElement(Icon_1.Icon, { icon: props.icon }) : null;
    var hasIconAndChildren = false;
    if (iconObject != null && props.children) {
        hasIconAndChildren = true;
    }
    var buttonCSS = classNames({
        'btn': true,
        'btn-default': normal,
        'btn-discrete': discrete,
        'btn-primary': primary,
        'btn-sm': small,
        'btn-xs': minimal,
        'btn-icon': hasIconAndChildren
    }, props.className);
    var whitespace = iconObject ? ' ' : '';
    var buttonType = props.buttonType, buttonSize = props.buttonSize, icon = props.icon, children = props.children, rest = __rest(props, ["buttonType", "buttonSize", "icon", "children"]);
    return (React.createElement("button", __assign({}, rest, { className: buttonCSS }),
        iconObject,
        whitespace,
        props.children));
}
exports.Button = Button;
//# sourceMappingURL=Button.js.map